import axios from "axios";

// ─── Environment ────────────────────────────────────────────
const API_URLS = {
  production: "https://api01.leon-gallery.com/api/",
  test: "http://157.230.43.47:3031/api/",
};

// Currently pointed at the TEST server (same as before)
const API_ENV = "production";

// ─── Helpers ────────────────────────────────────────────────
const LOGIN_PATH = "/login";

const getToken = () => localStorage.getItem("token");

const isValidToken = (token) =>
  Boolean(token) && token !== "null" && token !== "undefined";

// A promise that never settles, so the caller's .then/.catch
// doesn't run while the page redirects
const haltChain = () => new Promise(() => {});

const redirectTo = (path) => {
  window.location.replace(path);
  return haltChain();
};

// ─── Instance ───────────────────────────────────────────────
export const axiosInstant = axios.create({
  baseURL: API_URLS[API_ENV],
  maxBodyLength: Infinity,
});

// ─── Request: attach token ──────────────────────────────────
axiosInstant.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (isValidToken(token)) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ─── Response: auth handling ────────────────────────────────
axiosInstant.interceptors.response.use(
  (response) => response,
  (error) => {
    const token = getToken();
    const isLoginPage = window.location.pathname === LOGIN_PATH;
    const isLoginRequest = error.config?.url?.includes("login");

    if (error.response && token && !isLoginRequest) {
      const { status, data } = error.response;

      // Logged in on another device
      if (status === 401 && data?.code === "FORCE_LOGOUT") {
        localStorage.clear();
        return redirectTo(`${LOGIN_PATH}?reason=logged_out`);
      }

      // Normal unauthorized / forbidden
      if (status === 401 || status === 403) {
        localStorage.removeItem("@storage_Key");
        localStorage.removeItem("token");
        if (!isLoginPage) return redirectTo(LOGIN_PATH);
      }
    }

    // Other errors (logging only)
    if (error.message === "Network Error") {
      console.error("Network Error detected");
    } else if (error.message === "canceled" || axios.isCancel(error)) {
      console.warn("Request canceled");
    }

    return Promise.reject(error);
  }
);

export default axiosInstant;